/**
 * Streaming Mode
 */
 module.exports = {
	LIVE_STREAMING: 'liveStreaming',
	CLOUD_STREAMING: 'cloudStreaming',
};



//////////////////
// WEBPACK FOOTER
// ./src/base/playback/StreamingMode.js
// module id = 64
// module chunks = 0